"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[9736],{

/***/ 59736:
/***/ ((module) => {

module.exports = JSON.parse('{"created":"Skapat","teamCreated":"Teamet {teamName} har skapats","updated":"Uppdaterat","teamUpdated":"Teamet {teamName} är uppdaterat","deleted":"Borttaget","teamDeleted":"Teamet {teamName} är borttaget"}');

/***/ })

}]);